import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import CheckoutCustomer from './pages/CheckoutCustomer'; 
import FixPseq from './pages/FixPseq'; 
import AbsenWajah from './pages/AbsenWajah';
import './index.css';
import ReactDOM from 'react-dom/client';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/checkout-customer" element={<CheckoutCustomer />} />
      <Route path="/fix-pseq" element={<FixPseq />} />
      <Route path="/absen-wajah" element={<AbsenWajah />} />  
    </Routes>
  </Router>
);
